import { Injectable } from "@angular/core";
import { ConfigService } from "./config.service";
import { HttpServiceService } from "./http-service.service";

export interface FatcaInterface {
  ProductId: number;
  Res_USResident_Citizen: string;
  Res_USBirthPlace: string;
  Res_US_Res_Add: string;
  Res_US_Tel_Num: string;
  Res_Recv_Funds: string;
  // Res_Add_PO_Box: string;
  // Res_Attrny_US: string;
  CS_Dec_Form: string;
  W_9_Form: string;
  Fatca_Form: string;

  //IsUSPerson: string;
  Crsextensiontext: string;
  W8extensiontext: string;
  W9extensiontext: string;
  Fatcaextensiontext: string;
  CrsList: Crs[];
  W8: W8;
  W9: W9;
  Crsconfirm: boolean;
  termsandcondition: boolean;
  residentPakistani: boolean;
  consent: boolean;
  fatcaconsent: boolean;
}

export interface W9 {
  Name: string;
  EntityName: string;
  TaxClassification: string;
  isOther: boolean;
  otherExplanation: string;
  isLimited: boolean;
  addressInUsLine1: string;
  addressInUsLine2: string;
  State: string;
  City: string;
  PostCode: string;
  AccountNumber: string;
  PayeeCode: string;
  FatcaReportingCode: string;
  isAnyOtherRequester: boolean;
  RequesterName: string;
  RequesterAddressLine1: string;
  RequesterAddressLine2: string;
  RequesterState: string;
  RequesterCity: string;
  requesterPostCode: string;
  TypeOfTaxPayer: string;
  TaxNumber: string;
  isReportedByIRS: string;
}
export interface W8 {
  ReferenceNumber: string;
  FTIN: string;
  Name: string;
  DOB: string;
  CountryOfCitizenship: string;
  PermanentresidenceAddressLine1: string;
  PermanentresidenceAddressLine2: string;
  PermanentCountry: string;
  PermanentState: string;
  PermanentCity: string;
  PermanentPostalCode: string;

  MailingPermanentresidenceAddressLine1: string;
  MailingPermanentresidenceAddressLine2: string;
  MailingCountry: string;
  MailingState: string;
  MailingCity: string;
  MailingPostalCode: string;

  TaxPayerType: string;
  identificationNumber: string;
  TaxTreatyClaim: boolean;

  BeneficalOwnerCountry: string;
  TreatyPercentageRate: string;
  TypeOfIncome: string;
  Explanation: string;
  Article: string;
}
export interface FatcaInterfaceSec {
  ProductId: number;
  Res_USResident_Citizen: string;
  Res_USBirthPlace: string;
  Res_US_Res_Add: string;
  Res_US_Tel_Num: string;
  Res_Recv_Funds: string;
  Res_Add_PO_Box: string;
  Res_Attrny_US: string;
  CS_Dec_Form: string;
  W_9_Form: string;
  Fatca_Form: string;
  w_8_BEN_Form: string;
  IsUSPerson: string;
  Crsextensiontext: string;
  W8extensiontext: string;
  W9extensiontext: string;
  Fatcaextensiontext: string;
  CrsList: Crs[];
  SecUserId: string;
}

export interface Crs {
  TaxCountry: string;
  TaxCountryName: string;
  TinAvailable: String;
  TinNumber: string;
  Reason: string;
  ReasonExplantion: string;
}
@Injectable({
  providedIn: "root",
})
export class FatcaCrsService {
  public platform: string = "w";
  public SaveFatcaResURL: string = "FatcaCrs/FatcaCrsWebV6";
  public SaveFatcaResSecURL: string = "FatcaCrs/FatcaCrsWebV4Sec";
  public GetFatcaPDFURL: string = "FatcaCrs/GetFatcaPDF";

  constructor(
    private http: HttpServiceService,
    private config: ConfigService
  ) { }

  public dataobject: FatcaInterface = {
    W8: {
      ReferenceNumber: "",
      FTIN: "",
      Article: "",
      identificationNumber: "",
      Name: "",
      DOB: "",
      CountryOfCitizenship: "",
      PermanentresidenceAddressLine1: "",
      PermanentresidenceAddressLine2: "",
      PermanentCity: "",
      PermanentCountry: "",
      PermanentPostalCode: "",
      PermanentState: "",
      MailingCity: "",
      MailingCountry: "",
      MailingPermanentresidenceAddressLine1: "",
      MailingPermanentresidenceAddressLine2: "",
      MailingPostalCode: "",
      MailingState: "",
      TaxPayerType: "",
      TaxTreatyClaim: false,
      BeneficalOwnerCountry: "",
      TreatyPercentageRate: "",
      TypeOfIncome: "",
      Explanation: "",
    },

    W9: {
      otherExplanation: "",
      isOther: false,
      Name: "",
      State: "",
      EntityName: "",
      TaxClassification: "",
      isLimited: false,
      addressInUsLine1: "",
      addressInUsLine2: "",
      City: "",
      PostCode: "",
      AccountNumber: "",
      PayeeCode: "",
      FatcaReportingCode: "",
      isAnyOtherRequester: false,
      requesterPostCode: "",
      RequesterAddressLine1: "",
      RequesterAddressLine2: "",
      RequesterCity: "",
      RequesterName: "",
      RequesterState: "",
      TypeOfTaxPayer: "",
      TaxNumber: "",
      isReportedByIRS: "",
    },
    ProductId: 1,
    CS_Dec_Form: "",
    // Res_Add_PO_Box: "",
    //Res_Attrny_US: "",
    Res_Recv_Funds: "No",
    Res_USBirthPlace: "No",
    Res_USResident_Citizen: "No",
    Res_US_Res_Add: "No",
    Res_US_Tel_Num: "No",
    W_9_Form: "",

    //IsUSPerson: "",
    Crsextensiontext: "",
    W8extensiontext: "",
    W9extensiontext: "",
    Fatca_Form: "",
    Fatcaextensiontext: "",
    CrsList: [],
    Crsconfirm: true,
    termsandcondition: true,
    residentPakistani: true,
    consent: true,
    fatcaconsent: true,
  };

  public dataobjectSec: FatcaInterfaceSec = {
    ProductId: 1,
    CS_Dec_Form: "",
    Res_Add_PO_Box: "",
    Res_Attrny_US: "",
    Res_Recv_Funds: "",
    Res_USBirthPlace: "",
    Res_USResident_Citizen: "",
    Res_US_Res_Add: "",
    Res_US_Tel_Num: "",
    W_9_Form: "",
    w_8_BEN_Form: "",
    IsUSPerson: "",
    Crsextensiontext: "",
    W8extensiontext: "",
    W9extensiontext: "",
    Fatca_Form: "",
    Fatcaextensiontext: "",
    CrsList: [],
    SecUserId: "",
  };

  public CreatingFatcaCrsResponse(token, object) {
    console.log("FatcaObject", JSON.stringify(object));
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SaveFatcaResURL,
          object,
          token
        )
        .subscribe(
          (data: any) => {
            if (data?.response?.code == 1) {
              resolve(data);
            }
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public CreatingFatcaCrsResponseSec(token, object) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SaveFatcaResSecURL,
          object,
          token
        )
        .subscribe(
          (data: any) => {
            if (data?.response?.code == 1) {
              resolve(data);
            }
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public GetFatcaPDFDOC(token, object) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(this.config.server + this.GetFatcaPDFURL, object, token)
        .subscribe(
          (data: any) => {
            if (data?.response?.code == 1) {
              resolve(data);
            }
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
}
